import {
  QASClientApiFp,
  Configuration,
  TransactionRequest,
  Annotation,
  Metadata,
  TransactionCriteria,
  AnnotationCriteria,
  MetadataActionRequestActionEnum
} from '@jibo-cloud/qas-client'
import { getAxiosInstance } from './axios'
import { getAccessToken } from '../servicesClient'

const qas = QASClientApiFp(new Configuration({ basePath: process.env.JIBO_SERVICES_QAS }))

export const processTransactionService = async (params: TransactionRequest) =>
  (await (await qas.processTransaction(params))(getAxiosInstance(getAccessToken()))).data

export const processAnnotationService = async (params: Annotation) =>
  (await (await qas.processAnnotation(params))(getAxiosInstance(getAccessToken()))).data

export const getMetadataService = async (appName?: string) =>
  (await (await qas.getMetadata(appName))(getAxiosInstance(getAccessToken()))).data.items

export const saveMetadataService = async (action: MetadataActionRequestActionEnum, metadata: Metadata) =>
  (await (await qas.saveMetadata({ action, metadata }))(getAxiosInstance(getAccessToken()))).data

export const searchTransactionService = async (params: TransactionCriteria) =>
  (await (await qas.searchTransaction(params))(getAxiosInstance(getAccessToken()))).data.items

export const searchAnnotationService = async (params: AnnotationCriteria) =>
  (await (await qas.searchAnnotation(params))(getAxiosInstance(getAccessToken()))).data.items
